import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../../context/CartContext';
import Hero from '../../common/Hero';
import QuickContact from '../contact/QuickContact';
import { formatCurrency } from '../../../utils/currency';
import { useTranslation } from 'react-i18next';

const specs = [
  { labelKey: 'product.specs.author', value: 'Bruce' },
  { labelKey: 'product.specs.type', value: 'Drama' },
  { labelKey: 'product.specs.language', value: 'English' },
  { labelKey: 'product.specs.year', value: '2025' },
  { labelKey: 'product.specs.pages', value: '112' },
  { labelKey: 'product.specs.availability', value: 'product.availability.inStock' },
];

const related = [
  { id: 101, image: '/assets/imgs/SinglePage/Layer%2023%20copy%204.png', title: 'Book Name 01', price: 90.0 },
  { id: 102, image: '/assets/imgs/SinglePage/Layer%2053%20copy%205.png', title: 'Book Name 02', price: 90.0 },
  { id: 103, image: '/assets/imgs/SinglePage/Layer%2023%20copy%204.png', title: 'Book Name 03', price: 90.0 },
];

const ProductPage = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [format, setFormat] = useState('E-Book');
  const [qty, setQty] = useState(1);
  const { t, i18n } = useTranslation('common');
  const lng = (i18n.language || 'en').split('-')[0];
  const titleBase = {
    ar: 'اسم الكتاب', ur: 'کتاب کا نام', en: 'Book Name', fr: 'Nom du livre', de: 'Buchtitel', es: 'Nombre del libro', pt: 'Nome do livro', ja: '書名', hi: 'पुस्तक का नाम', it: 'Nome del libro', ru: 'Название книги', zh: '书名'
  }[lng] || 'Book Name';
  const fmtNum = new Intl.NumberFormat(lng);
  const authorMap = { ar: 'بروس', ur: 'بروس', en: 'Bruce', fr: 'Bruce', de: 'Bruce', es: 'Bruce', pt: 'Bruce', ja: 'ブルース', hi: 'ब्रूस', it: 'Bruce', ru: 'Брюс', zh: '布鲁斯' };
  const typeMap = { ar: 'دراما', ur: 'ڈرامہ', en: 'Drama', fr: 'Drame', de: 'Drama', es: 'Drama', pt: 'Drama', ja: 'ドラマ', hi: 'ड्रामा', it: 'Dramma', ru: 'Драма', zh: '剧情' };
  const langMap = { ar: 'الإنجليزية', ur: 'انگریزی', en: 'English', fr: 'Anglais', de: 'Englisch', es: 'Inglés', pt: 'Inglês', ja: '英語', hi: 'अंग्रेज़ी', it: 'Inglese', ru: 'Английский', zh: '英语' };

  const product = {
    id: 100,
    title: `${titleBase} 01`,
    image: '/assets/imgs/SinglePage/Oasis-T1-Cover_01%20copy%205.png',
    price: 90.0,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
  };

  const handleAdd = () => {
    addToCart({ id: product.id, title: product.title, image: product.image, price: product.price }, qty);
  };
  const handleBuyNow = () => {
    handleAdd();
    navigate('/checkout');
  };

  return (
    <div className="bg-cream min-h-screen">
      {/* Hero / breadcrumb area */}
      <Hero
        title={t('product.hero')}
        backgroundImage="/assets/imgs/SinglePage/Banner.png"
        showSocial={false}
        showPlay={false}
        heightClasses="h-[30vh] md:h-[40vh] lg:h-[45vh]"
        bgSize="cover"
        bgPosition="center"
      />

      {/* Breadcrumb */}
      <div className="bg-cream">
        <div className="container mx-auto px-8 lg:px-16 py-4 text-sm text-text-gray">
          {/* Home / Product / <span className="text-text-dark">{product.title}</span> */}
        </div>
      </div>

      {/* Product section */}
      <section className="py-12 lg:py-16">
        <div className="container mx-auto px-8 lg:px-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-text-dark text-center">{t('home.comicBooks.title')}</h2>
          <p className="text-base font-medium text-text-dark mt-1 mb-8 text-center">{t('home.comicBooks.featured')}</p>
          <div className="flex flex-col lg:flex-row gap-10 items-start">
            {/* Left image */}
            <div className="bg-[#e8dcc8] border-2 border-text-dark rounded-lg overflow-hidden shadow-sm flex-1 lg:self-stretch flex items-center justify-center max-w-[460px] w-full lg:max-h-[520px] p-4">
              <img src={product.image} alt={product.title} className="h-full w-auto object-contain" />
            </div>

            {/* Right details */}
            <div className="flex-1 min-w-[300px]">
              <h3 className="text-2xl font-bold text-text-dark mb-3">{product.title}</h3>
              <p className="text-text-gray leading-relaxed mb-5">
                {product.description}
              </p>

              <div className="flex items-end gap-4 mb-6">
                <div className="text-text-dark text-sm">{t('product.priceLabel')}</div>
                <div className="text-2xl font-extrabold text-price-red">{formatCurrency(product.price)}</div>
              </div>

              <ul className="grid grid-cols-2 gap-y-2 text-sm text-text-dark mb-6">
                {specs.map(s => {
                  let value = s.value;
                  if (value === 'Bruce') value = authorMap[lng] || value;
                  if (value === 'Drama') value = typeMap[lng] || value;
                  if (value === 'English') value = langMap[lng] || value;
                  if (/^\d+$/.test(value)) value = fmtNum.format(Number(value));
                  const isKey = typeof value === 'string' && value.startsWith('product.');
                  return (
                    <li key={s.labelKey} className="flex">
                      <span className="w-28 text-text-gray">{t(s.labelKey)} :</span>
                      <span className="font-medium">{isKey ? t(value) : value}</span>
                    </li>
                  );
                })}
              </ul>

              {/* Options */}
              <div className="flex items-center gap-4 mb-6">
                <div>
                  <label className="block text-xs text-text-gray mb-1">{t('product.format')}</label>
                  <select
                    value={format}
                    onChange={(e) => setFormat(e.target.value)}
                    className="px-3 py-2 border border-[#cdbfb2] bg-white rounded text-sm text-text-dark"
                  >
                    <option>{t('shop.badges.eBook')}</option>
                    <option>{t('shop.badges.paperBook')}</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs text-text-gray mb-1">{t('product.quantity')}</label>
                  <div className="flex items-center border border-[#cdbfb2] rounded">
                    <button onClick={() => setQty(q => Math.max(1, q-1))} className="px-3 py-2 text-text-gray">-</button>
                    <span className="px-4 py-2 text-text-dark text-sm">{qty}</span>
                    <button onClick={() => setQty(q => q+1)} className="px-3 py-2 text-text-gray">+</button>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap gap-3 mb-8">
                <button onClick={handleAdd} className="px-6 py-3 bg-brown text-cream rounded-md text-sm font-semibold tracking-wide hover:bg-brown-dark">{t('shop.actions.addToCart')}</button>
                <button onClick={handleBuyNow} className="px-6 py-3 bg-gold text-white rounded-md text-sm font-semibold tracking-wide hover:bg-yellow-600">{t('shop.actions.buyNow')}</button>
                <button className="px-6 py-3 bg-[#a49386] text-white rounded-md text-sm font-semibold tracking-wide">{t('product.addToWish')}</button>
              </div>

              <div className="text-sm text-text-gray">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante. Sed posuere consectetur est at lobortis. Vivamus sagittis lacus vel augue laoreet rutrum.
              </div>
            </div>
          </div>
          {/* Long description box */}
          <div className="mt-12">
            <div className="border border-[#cdbfb2] rounded bg-white">
              <div className="bg-gold text-white px-5 py-2 font-semibold tracking-wide uppercase text-sm rounded-t">
                {t('product.description')}
              </div>
              <div className="px-6 py-5 text-text-gray leading-relaxed">
                <p className="mb-4">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                <p>
                  Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related products */}
      <section className="pb-16">
        <div className="container mx-auto px-8 lg:px-16">
          <h3 className="text-3xl md:text-4xl font-bold text-text-dark mb-8 text-center">{t('product.related')}</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {related.map(r => {
              const num = (String(r.title).match(/(\d{1,2})$/)?.[1] || '01').padStart(2,'0');
              const localized = `${titleBase} ${num}`;
              return (
                <div key={r.id} className="group">
                  <div className="relative bg-[#e8dcc8] border-2 border-text-dark rounded overflow-hidden aspect-[3/4] mb-3 p-3">
                    <img src={r.image} alt={localized} className="w-full h-full object-contain" />
                  </div>
                  <div className="flex items-center justify-between mb-1">
                    <h5 className="text-base font-medium text-text-dark">{localized}</h5>
                    <div className="flex gap-0.5">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="#ffcb36"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                      ))}
                    </div>
                  </div>
                  <p className="text-base font-bold text-price-red">{formatCurrency(r.price)}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <QuickContact />
    </div>
  );
};

export default ProductPage;
